import React, { ReactNode } from "react";
import styles from "./FormContainer.module.scss";
import { createPostFixedElementName } from "../../shared/helpers/element.naming";

export interface FormContainerProps {
  pageName: string;
  title: string;
  messages?: Array<string>;
  fields: ReactNode;
  action: ReactNode;
  image?: ReactNode;
  footer?: ReactNode;
}
export const FormContainer = (props: FormContainerProps) => {
  const titleElementName = `${props.pageName}_pagetitle_label`;
  const informationElementName = `${props.pageName}_pageinformation_label`;
  const showFooterContainer = !!props.footer;

  let hasImage = false;
  let fieldContainerClassName = styles.fields_container;
  let blockContainerClassName = styles.block_container;
  if (props.image) {
    hasImage = true;
    fieldContainerClassName = styles.fields_container_with_image;
    blockContainerClassName = styles.block_container_with_image;
  }
  return (
    <div className={styles.outer_container}>
      <div className={styles.inner_container}>
        {hasImage && <div className={styles.logo_container}>{props.image}</div>}
        <div className={fieldContainerClassName}>
          <div className={blockContainerClassName}>
            <div className={styles.headers_container}>
              <h1 id={titleElementName} data-name={titleElementName} className={styles.title}>
                {props.title}
              </h1>
              {props.messages &&
                props.messages.map((message, index) => (
                  <p
                    id={createPostFixedElementName(informationElementName, index)}
                    data-name={createPostFixedElementName(informationElementName, index)}
                    className={styles.information}
                    key={index}
                  >
                    {message}
                  </p>
                ))}
            </div>
            {props.fields}
            <div className={styles.action_container}>{props.action}</div>
          </div>
          {showFooterContainer && (
            <div className={styles.block_container}>
              <div className={styles.footer_container}>{props.footer}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
